import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Colors, Fonts } from '../../Utils/theme'

const useStyles = makeStyles((theme) => ({
  infoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 1400,
    height: 200
  },
  infoText: {
    fontSize: '2rem',
    color: Colors.content,
    fontFamily: Fonts.content,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.75rem'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.5rem'
    }
  }
}))

function DataMessage (props) {
  const classes = useStyles()
  if (!props.data || !props.data.length) {
    return (
      <div className={classes.infoContainer}>
        <p className={classes.infoText}>{props.message}</p>
      </div>
    )
  }
  return null
}

export default DataMessage
